import React from 'react';
import { useHtmlSnapshot } from '../hooks';

const AhaContents = ({
  ahaContents,
  width = 'initial',
  height = 'auto',
  padding = [0, 0],
}) => {
  // A large fraction of the content in a dashboard panel is just report
  // html that has been rendered normally via a call to the server, and
  // then is 'dangerously' set here. In the case of displaying as a shared
  // webpage, all the needed html to already there an no fetch requests
  // should be needed. The trick is to get react to just use whatever
  // html has already been set via `dangerouslySetInnerHTML`. Referring to
  // https://github.com/facebook/react/issues/12617, it appears that
  // passing a blank string acheives just this. This is an undocumented
  // react behavior, but the alternatives offered in the above issue
  // were not any better. If this behavior ever changes, we'll likely
  // need to significantly refactor how dashboard panels are rendered
  // in a shared webpage context.
  const shouldUseHtmlSnapshot = useHtmlSnapshot();
  const paddingStr = `${padding[0]}px ${padding[1]}px`;
  return (
    <div
      style={{ height, width, padding: paddingStr }}
      suppressHydrationWarning
      // contents come from html snapshots on the server
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{
        __html: shouldUseHtmlSnapshot ? '' : ahaContents,
      }}
    />
  );
};

export default AhaContents;
